<template>
    <div v-click-away="closeMenu" :class="menuClass">
        <button type="button" class="app-user-menu__name" @click="toggleMenu">
            <div class="app-user-menu__avatar">
                <div v-if="$auth.isMemberActivated()" class="app-user-menu__avatar--admin">
                    {{ $t('common.microcopy.admin') }}
                </div>
                <common-user-avatar :withBorder="true" :user="user" size="medium-small"></common-user-avatar>
            </div>
        </button>

        <common-dropdown :isOpen="isDropdownOpen" :recalculatePosition="false" arrowPositionY="top" arrowPositionX="right">
            <nav class="dropdown__menu">
                <div class="app-user-menu__user-data">
                    <div class="app-user-menu__user-data--title">{{ $t('common.microcopy.account') }}</div>
                    <div class="app-user-menu__user-data--data">
                        <common-user-avatar :user="user" size="medium"></common-user-avatar>
                        <div>
                            <span>{{ user.firstName }} {{ user.lastName }}</span>
                            <div class="app-user-menu__user-data--email">{{ user.email }}</div>
                        </div>
                    </div>
                </div>
                <button type="button" @click="goToProfile()">{{ $t('layouts.app.user_menu.profile') }}</button>
                <hr />
                <button v-if="$auth.isMemberActivated()" type="button" @click="goBackToAdminProfile()">
                    {{ $t('layouts.app.user_menu.go_to_admin_profile') }}
                </button>
                <hr />
                <button type="button" @click="logout()">{{ $t('layouts.app.user_menu.logout') }}</button>
            </nav>
        </common-dropdown>
    </div>
</template>

<script>
    import RoutesEnum from 'enums/routes.enum'

    export default {
        data() {
            return {
                isDropdownOpen: false,
            }
        },

        computed: {
            menuClass() {
                return {
                    'app-user-menu': true,
                    'app-user-menu--is-open': this.isDropdownOpen,
                }
            },

            user() {
                return this.$auth.getUser()
            },

            userName() {
                if (this.user.firstName && this.user.lastName) {
                    return `${this.user.firstName} ${this.user.lastName}`
                }
                return null
            },
        },

        methods: {
            toggleMenu() {
                this.isDropdownOpen = !this.isDropdownOpen
            },

            closeMenu() {
                this.isDropdownOpen = false
            },

            goToProfile() {
                this.toggleMenu()
                this.$router.push({ name: RoutesEnum.USER.ME, params: { tabType: 'profile' } })
            },

            logout() {
                this.$auth.logout()
            },

            async goBackToAdminProfile() {
                this.$auth.createSession({
                    accessToken: localStorage.getItem('admin_access_token'),
                    refreshToken: localStorage.getItem('admin_refresh_token'),
                    loginType: localStorage.getItem('admin_login_type'),
                })

                await this.$router.push({ name: RoutesEnum.INDEX.HOME })
                window.location.reload()
            },
        },
    }
</script>
